import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import CategoriesSection from '../components/CategoriesSection';
import WhyChooseUs from '../components/WhyChooseUs';
import FeaturedProducts from '../components/FeaturedProducts';
import PromoBanner from '../components/PromoBanner';
import RoomLookbook from '../components/RoomLookbook';
import VisitNowSection from '../components/VisitNowSection';
import ReviewsSection from '../components/ReviewsSection';
import Seo from '../components/Seo';

const Home = () => {
  return (
    <div className="bg-white min-h-screen">
      <Seo
        title="Satis Furniture Sydney | Factory Outlet Furniture Shop in Campsie NSW"
        description="Satis Furniture is a family-owned outlet store in Campsie, Sydney. Beds, mattresses, sofas, wardrobes, dining sets and more at factory-direct prices. Free local delivery within 10km."
        path="/"
      />
      <Header />
      <Hero />
      <CategoriesSection />
      <WhyChooseUs />
      <FeaturedProducts />
      <PromoBanner />
      <RoomLookbook />
      <VisitNowSection />
      <ReviewsSection />
      <Footer />
    </div>
  );
};

export default Home;
